import { render, staticRenderFns } from "./TwoFactorAuthorization.vue?vue&type=template&id=76b9d0fa&scoped=true&"
import script from "./TwoFactorAuthorization.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b9d0fa",
  null
  
)

export default component.exports